import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { ExamSessionListItem, fetchExamSessions } from '../../api/exam'
import { format } from 'date-fns'
import { zhCN } from 'date-fns/locale'
import { ROUTES, generatePath } from '@/constants/routes'

export default function ExamHistoryPage() {
  const navigate = useNavigate()
  const [sessions, setSessions] = useState<ExamSessionListItem[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let mounted = true
    setLoading(true)
    fetchExamSessions()
      .then((data) => {
        if (mounted) {
          setSessions(data)
        }
      })
      .catch((err: unknown) => {
        if (mounted) {
          setError(err instanceof Error ? err.message : String(err))
        }
      })
      .finally(() => {
        if (mounted) {
          setLoading(false)
        }
      })
    return () => {
      mounted = false
    }
  }, [])

  return (
    <div className="p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold">答题历史</h1>
        <Link to={ROUTES.EXAM} className="text-sm text-blue-600 hover:underline">
          返回试卷列表
        </Link>
      </div>

      {loading && <div>加载中...</div>}
      {error && <div className="text-red-500 text-sm">{error}</div>}

      {!loading && !error && sessions.length === 0 && (
        <div className="text-center text-muted-foreground py-8">
          暂无答题记录
        </div>
      )}

      {!loading && !error && sessions.length > 0 && (
        <div className="border rounded-md overflow-hidden">
          <table className="w-full text-sm text-left">
            <thead className="bg-muted text-muted-foreground font-medium border-b">
              <tr>
                <th className="px-4 py-3">试卷名称</th>
                <th className="px-4 py-3">开始时间</th>
                <th className="px-4 py-3">状态</th>
                <th className="px-4 py-3">得分</th>
                <th className="px-4 py-3 text-right">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {sessions.map((session) => (
                <tr key={session.id} className="hover:bg-muted/50">
                  <td className="px-4 py-3">
                    <div className="font-medium">{session.paper.name}</div>
                    <div className="text-xs text-muted-foreground mt-0.5">
                      {session.paper.subject} · {session.paper.grade}
                    </div>
                  </td>
                  <td className="px-4 py-3">
                    {format(new Date(session.started_at), 'yyyy-MM-dd HH:mm', { locale: zhCN })}
                  </td>
                  <td className="px-4 py-3">
                    {session.status === 'completed' ? (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-green-100 text-green-800">
                        已完成
                      </span>
                    ) : (
                      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-yellow-100 text-yellow-800">
                        进行中
                      </span>
                    )}
                  </td>
                  <td className="px-4 py-3 font-medium">
                    {session.status === 'completed' ? (
                      session.total_score ?? '-'
                    ) : (
                      <span className="text-muted-foreground">-</span>
                    )}
                  </td>
                  <td className="px-4 py-3 text-right">
                    {session.status === 'in_progress' ? (
                      <button
                        onClick={() => navigate(generatePath(ROUTES.EXAM_SESSION, { sessionId: session.id }))}
                        className="text-blue-600 hover:underline font-medium"
                      >
                        继续答题
                      </button>
                    ) : (
                      <button
                        onClick={() => navigate(generatePath(ROUTES.EXAM_SESSION, { sessionId: session.id }))} // Or report page if exists
                        className="text-blue-600 hover:underline"
                      >
                        查看报告
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
